import React from "react";
import { RaisedButton, TextField, Styles } from "material-ui";
import Helmet from "react-helmet";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../actions/PersonActions";
import PersonStore from "../stores/PersonStore";

@connectToStores
class Forgot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: ""
    };

    this._reset = this._reset.bind(this);
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  _reset() {
    PersonActions.forgotPassword(this.state.email);
  }

  getStyles() {
    return {
      container: {
        margin: "20px auto",
        marginTop: "10%",
        width: 270,
        fontSize: "11pt"
      },
      actions: {
        marginTop: 10,
        textAlign: "center"
      },
      error: {
        color: "#FF4136"
      }
    };
  }

  render() {
    var styles = this.getStyles();

    return (
      <div style={styles.container}>
        <Helmet title="Forgot password" />
        {this.props.forgotSuccess ? (
          <div>
            Please check your email for instructions to reset your password.
          </div>
        ) : (
          <div>
            {this.props.forgotErrorMessage ? (
              <div style={styles.error}>{this.props.forgotErrorMessage}</div>
            ) : (
              <div>
                To begin the password recovery process, please enter your email
                address.
              </div>
            )}
            <form>
              <div>
                <TextField
                  hintText="Email address"
                  value={this.state.email}
                  fullWidth={true}
                  onChange={e => this.setState({ email: e.target.value })}
                  autoFocus={true}
                  disabled={this.props.forgotInProgress}
                />
              </div>
              <div style={styles.actions}>
                <RaisedButton
                  label={
                    this.props.forgotInProgress
                      ? "Resetting..."
                      : "Reset password"
                  }
                  disabled={this.props.forgotInProgress}
                  primary={true}
                  onClick={this._reset}
                />
                <RaisedButton
                  label="Go back"
                  style={{ marginLeft: 12 }}
                  onClick={this.context.router.goBack}
                />
              </div>
            </form>
          </div>
        )}
      </div>
    );
  }
}

export default Forgot;



// WEBPACK FOOTER //
// ./src/app/components/forgot.jsx